var _a;
import { UrlMappingsKeys } from '../url-mappings-keys';
export var blogMapping = (_a = {},
    _a[UrlMappingsKeys.BLOG_CATEGORY] = {
        variables: ['slug'],
        required: ['slug'],
        defaultPrefix: 'categories',
    },
    _a);
//# sourceMappingURL=blog.js.map